export enum AccessRestriction {
  NONE = "NONE",
  PASSWORD = "PASSWORD",
}
